<template>
  <section class="mt-4 pb-4">
    <h2 class="text-xl md:text-2xl xl:text-3xl leading-tight font-semibold text-center mb-6">
      Trusted by pioneering dealers
    </h2>

    <div class="flex items-center justify-center xl:justify-between gap-x-2 gap-y-3 max-xl:flex-wrap max-md:child:w-40">
      <img src="@/assets/images/dealers/gem-mint.png" alt="GEM MINT dealer logo">
      <img src="@/assets/images/dealers/blez.png" alt="BLEZ dealer logo">
      <img src="@/assets/images/dealers/dave-adams.png" alt="DAVE & ADAM'S dealer logo">
      <img src="@/assets/images/dealers/vintage-card.png" alt="VINTAGE CARD COMPANY dealer logo">
    </div>
  </section>
</template> 